module.exports = __webpack_public_path__ + "static/media/paraicon2.5804c846.webp";